<template>
  <sc-select
    v-model="occurrence"
    expanded>
    <option
      v-for="occurrence in occurrencesList"
      :key="occurrence.value"
      :value="occurrence.value">
      {{ occurrence.label }}
    </option>
  </sc-select>
</template>

<script>
  import { ScSelect } from '@intelipost-js/secure-components';

  export default{
    name: 'sc-reports-occurrences-dropdown',
    props: {
      value: {
        type: String,
      },
    },
    data() {
      return {
        occurrence: this.value,
        occurrencesList: [
          {
            label: 'Todos os pedidos',
            value: null,
          },
          {
            label: 'Sem ocorrências',
            value: 'false',
          },
          {
            label: 'Com ocorrências',
            value: 'true',
          },
        ],
      };
    },
    watch: {
      value(value) {
        this.occurrence = value;
      },
      occurrence() {
        this.$emit('input', this.occurrence);
      },
    },
    components: {
      ScSelect,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-analytic/features/reports/components/sc-reports-occurrences-dropdown/ScReportsOccurrencesDropdown.vue?4d32538d